<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid shipping-search">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Shipping Search</h4>
            <shippingSearchForm class="mt-4"></shippingSearchForm>
            <router-view />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import ShippingSearchForm from "./ShippingSearchForm.vue";
export default {
  name: "ShippingSearch",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    shippingSearchForm: ShippingSearchForm,
  },
  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "shippingSearch",
        activeMenu: this.activeMenu ? this.activeMenu : "crm-tools",
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>
<style lang="scss" scoped>
.shipping-search {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

html,
body {
  height: 100%;
}
</style>
